import type {
  AchFieldKeys,
  WireFieldKeys,
  CheckFieldKeys,
  AchVisibleFields,
  WireVisibleFields,
  CheckVisibleFields,
} from "../types";

// Generic base function
export const isFieldVisible = <T extends string>(
  fieldName: T,
  visibleFields?: T[],
): boolean => {
  if (!visibleFields) return true;
  return visibleFields.includes(fieldName);
};

// Typed helpers using existing field key types
export const isAchFieldVisible = (
  fieldName: AchFieldKeys,
  visibleFields?: AchVisibleFields,
): boolean => isFieldVisible(fieldName, visibleFields);

export const isWireFieldVisible = (
  fieldName: WireFieldKeys,
  visibleFields?: WireVisibleFields,
): boolean => isFieldVisible(fieldName, visibleFields);

export const isCheckFieldVisible = (
  fieldName: CheckFieldKeys,
  visibleFields?: CheckVisibleFields,
): boolean => isFieldVisible(fieldName, visibleFields);
